const files = require.context('./modules', true, /\.js$/)
const filesArr = files.keys().map(apiName=> files(apiName).default || files(apiName))

let filesObj = {}
filesArr.map(item => {
    for(let key in item){
        filesObj[key] = JSON.parse(JSON.stringify(item[key]))
    }
})

module.exports = filesObj